// Données pour les visites précédentes
export const previousVisitsData = [
    {
      id: 'v1',
      date: {
        day: '08',
        month: 'OCT',
        year: '2025'
      },
      reasonForVisit: 'Persistent headaches and fatigue',
      conclusion: 'Mild Iron Deficiency Anemia',
      metrics: [
        {
          id: 'm1',
          label: 'Blood Pressure:',
          value: '76',
          unit: 'bpm',
          icon: 'cont1'
        },
        {
          id: 'm2',
          label: 'Blood Pressure:',
          value: '125/80',
          unit: 'mmHg',
          icon: 'cont2'
        },
        {
          id: 'm3',
          label: 'Heart Rate',
          value: '37.1',
          unit: '°C',
          icon: 'cont3'
        },
        {
          id: 'm4',
          label: 'Blood Glucose',
          value: '92',
          unit: 'mg/dL',
          icon: 'cont4'
        }
      ]
    },
    {
      id: 'v2',
      date: {
        day: '15',
        month: 'SEP',
        year: '2025'
      },
      reasonForVisit: 'Annual checkup and vaccination',
      conclusion: 'Healthy - All vitals normal',
      metrics: [
        {
          id: 'm1',
          label: 'Blood Pressure:',
          value: '72',
          unit: 'bpm',
          icon: 'cont1'
        },
        {
          id: 'm2',
          label: 'Blood Pressure:',
          value: '120/78',
          unit: 'mmHg',
          icon: 'cont2'
        },
        {
          id: 'm3',
          label: 'Heart Rate',
          value: '36.8',
          unit: '°C',
          icon: 'cont3'
        },
        {
          id: 'm4',
          label: 'Blood Glucose',
          value: '88',
          unit: 'mg/dL',
          icon: 'cont4'
        }
      ]
    },
    {
      id: 'v3',
      date: {
        day: '22',
        month: 'AUG',
        year: '2025'
      },
      reasonForVisit: 'Respiratory infection symptoms',
      conclusion: 'Acute Bronchitis - Prescribed antibiotics',
      metrics: [
        {
          id: 'm1',
          label: 'Blood Pressure:',
          value: '82',
          unit: 'bpm',
          icon: 'cont1'
        },
        {
          id: 'm2',
          label: 'Blood Pressure:',
          value: '128/82',
          unit: 'mmHg',
          icon: 'cont2'
        },
        {
          id: 'm3',
          label: 'Heart Rate',
          value: '38.2',
          unit: '°C',
          icon: 'cont3'
        },
        {
          id: 'm4',
          label: 'Blood Glucose',
          value: '95',
          unit: 'mg/dL',
          icon: 'cont4'
        }
      ]
    }
  ];
  
  // Données pour les traitements précédents
  export const previousTreatmentsData = [
    {
      id: 't1',
      medicine: 'Amoxicillin',
      dosage: '500 mg',
      dose: '1 capsule',
      frequency: '3 times a day',
      startDay: '29/10/2025',
      duration: '7 days',
      status: 'Ongoing',
      statusType: 'ongoing'
    },
    {
      id: 't2',
      medicine: 'Amoxicillin',
      dosage: '500 mg',
      dose: '1 capsule',
      frequency: '3 times a day',
      startDay: '29/10/2025',
      duration: '7 days',
      status: 'Ongoing',
      statusType: 'ongoing'
    },
    {
      id: 't3',
      medicine: 'Ibuprofen',
      dosage: '400 mg',
      dose: '1 tablet',
      frequency: '2 times a day',
      startDay: '22/10/2025',
      duration: '5 days',
      status: 'Completed',
      statusType: 'completed'
    },
    {
      id: 't4',
      medicine: 'Vitamin D3',
      dosage: '1000 IU',
      dose: '1 capsule',
      frequency: 'Once daily',
      startDay: '15/09/2025',
      duration: '30 days',
      status: 'Completed',
      statusType: 'completed'
    },
    {
      id: 't5',
      medicine: 'Azithromycin',
      dosage: '250 mg',
      dose: '2 tablets',
      frequency: 'Once a day',
      startDay: '22/08/2025',
      duration: '5 days',
      status: 'Completed',
      statusType: 'completed'
    },
    {
      id: 't6',
      medicine: 'Paracetamol',
      dosage: '500 mg',
      dose: '1-2 tablets',
      frequency: 'As needed',
      startDay: '22/08/2025',
      duration: '7 days',
      status: 'Completed',
      statusType: 'completed'
    }
  ];
  
  // Options pour les statuts de traitement
  export const treatmentStatusOptions = [
    { value: 'ongoing', label: 'Ongoing', className: 'status-ongoing' },
    { value: 'completed', label: 'Completed', className: 'status-completed' },
    { value: 'discontinued', label: 'Discontinued', className: 'status-discontinued' }
  ];
  
  // Fonction helper pour obtenir la dernière visite
  export const getLatestVisit = () => {
    return previousVisitsData[0];
  };
  
  // Fonction helper pour obtenir tous les traitements en cours
  export const getOngoingTreatments = () => {
    return previousTreatmentsData.filter(treatment => treatment.statusType === 'ongoing');
  };
  
  // Fonction helper pour obtenir tous les traitements terminés
  export const getCompletedTreatments = () => {
    return previousTreatmentsData.filter(treatment => treatment.statusType === 'completed');
  };